import { components } from "swagger/types";
import { TableRowId } from "@fluentui/react-components";

export interface SupportedLanguage {
  isGrECoLanguage: boolean;
  code: string;
  isDeleted: boolean;
  id: number;
}

export type TaxonomyKey = any;

export type Taxonomy = {
  code: string;
  id: number;
};

// export interface IAuthorization
//   extends Partial<components["schemas"]["UserAuthorizationInfo"]> {}

export interface ICommonAttributes {
  rowVersion?: string; // required
  backgroundPictureName?: string;
  backgroundPictureContent?: string;
  backgroundPictureMimeType?: string;
  backgroundPicturePath?: string;
  lastModifiedAt?: string; // readOnly
  lastModifiedByUserId?: string; // readOnly
  lastModifiedByUserName?: string; // readOnly
  lastModifiedByUserEmail?: string; // readOnly
  createdAt?: string; // readOnly
  createdByUserId?: string; // readOnly
  createdByUserName?: string; // readOnly
  createdByUserEmail?: string; // readOnly
}

export interface INotification {
  fieldName?: string;
  text: string;
  id: string;
  handleClearNotification?: (message: INotification) => void;
  type: "error" | "info" | "warning" | "success";
  // notify: INotify;
}

export interface INotify {
  notifyText: string;
  type: string;
  notifyCode: string;
  label: string;
}

export interface IErrorHandler {
  value: string;
  type: string;
  label: string;
  fieldName?: string;
  errors?: any;
}

export interface IUser {
  "@odata.context": string;
  businessPhones?: any[];
  displayName?: string;
  givenName?: string;
  jobTitle?: string | null;
  mail?: string | null;
  mobilePhone?: string;
  officeLocation?: string | null;
  preferredLanguage?: string;
  surname?: string;
  userPrincipalName?: string;
  id?: string;
  photoMedium?: string;
}

export enum ECheckedValue {
  Yes = "yes",
  No = "no",
}

export enum EPaidBy {
  Percentage = "Percentage",
  Amount = "Amount",
}

export type SelectItem = {
  text: string;
  value: string | number;
  Icon?: JSX.Element;
  [x: string]: any;
};

export enum EAppSettings {
  language = "Language",
  darkMode = "Dark_Mode",
  theme = "Theme",
  benefitViewMode = "Benefit_View_Mode",
}

export enum EImageView {
  list = "list",
  details = "details",
  tiles = "tiles",
  largeImages = "largeImages",
  smallImages = "smallImages",
  mediumImages = "mediumImages",
}

export type IFormattedFile = {
  name: string | null;
  path?: string | null;
  base64String: string | null;
  type: string | null;
};
export type IFormattedFileExtended = IFormattedFile & {
  isAttachHiddenForEmployee: boolean;
};

export interface IFile {
  base64Str?: string;
  name: string;
}

export type IGrecoClient = {
  id: number;
  internalNumber: number;
  name: string;
  countryCodeId: number;
  currencyCodeId: number;
  isCompany?: boolean;
  label?: string;
  value?: string;
  clientInternalNumberGos?: number;
  currencyCode?: string;
};

export interface IBackendError {
  statusCode: number;
  errorCode: string;
  type: string;
  correlationID: string;
  messageCode: string;
  messageVariables: any[];
  statusDescription: string;
  message: string;
  formatedMessage: string;
  exceptionMessage: string;
  stackTrace: string;
}

export interface IInsurer {
  Id: number;
  InternalNumber: number;
  Name: string;
  CountryCodeId: number;
  IsCompany: boolean;
}
export interface ITaxonomy
  extends Partial<components["schemas"]["TaxonomyData"]> {}

export interface IUserSettings
  extends Partial<components["schemas"]["UserSettings"]> {}
export interface IUserSettingsPayload
  extends Partial<components["schemas"]["UserSettingsRequest"]> {}

export interface IAzureSearchResult
  extends Partial<components["schemas"]["AzureSearchResult"]> {}

export interface IAzureSearchData
  extends Partial<components["schemas"]["AzureSearchData"]> {}
